import GrnEntryReducer from './GrnEntry/slice';
export default GrnEntryReducer;
